<template>
  <!-- Leaderboard Section -->
  <section id="leaderboards"
    class="h-full bg-no-repeat relative overflow-hidden pt-10 bg-leaderboard-bg">
    <div class="absolute inset-0 w-full h-full bg-center bg-[#080809]/50"></div>
    <img src="@/assets/overlay-5.avif"
      class="absolute bottom-0 -left-28 block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px] max-h-[1539px]"
      alt="overlay 1" />
    <img src="@/assets/overlay-6.avif"
      class="absolute top-0 -right-28 block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px] max-h-[1539px]"
      alt="overlay 2" />
    <img src="@/assets/planet-4.webp"
      class="absolute bottom-[269px] left-0  block object-contain w-auto h-[94px] md:h-[186px]"
      alt="planet 1" />
    <img src="@/assets/planet-5.webp"
      class="absolute top-[548px] md:top-[363px] right-0  block object-contain w-auto h-[95px] md:h-[384px]"
      alt="planet 1" />
    <img src="@/assets/overlay-3.avif"
        class="absolute bottom-0 z-10 block object-cover object-center w-full h-auto max-h-[637px]"
        alt="overlay 1" />
    <div class="flex items-center justify-center w-full px-4 md:px-0 lg:pt-0">
      <div class="w-full flex flex-col justify-center items-center my-8 md:mb-10 md:mt-0 md:p-4 rounded-3xl z-10">
        <div class="text-center text-white">
          <!-- Logo -->
          <img src="../assets/goated-logo.png" class="h-[35px] w-auto object-contain z-20 lg:h-20 xl:h-[85px] 2xl:h-[100px]" alt="hero text">
          <h1 class="text-2xl md:text-[32px] md:leading-10 tracking-wide font-bold font-orbitron text-white uppercase md:text-3xl text-center text-shadow">LEADERBOARD</h1>
        </div>
        <div class="flex flex-col items-center justify-center my-10 lg:mt-20 lg:mb-5">
          <div class="mb-20 bg-gradient-to-b from-[#191822] to-[#5C3EB7]/20 border border-[#5C3EB7] bg-opacity-20 text-center py-4 md:py-7 px-24 md:px-40 rounded-2xl text-white font-orbitron">
            <p class="text-[32px] leading-[37px] md:text-5xl md:leading-[60px]">$2,000.00</p>
            <span class="sm:hidden text-base text-center leading-[20px]">Prize pool</span>
          </div>
          <div class="bg-transparent">
            <div class="bg-transparent font-internet">
              <div v-if="!selectedLeaderboard && timer && timer !== 'Leaderboard ended'" class="flex flex-row gap-3">
                <div class="relative rounded-[10px] h-[70px] w-[70px] border-[2px] border-[#5C3EB7] bg-black/20 shadow-[0_6px_50px_0_#5C3EB7]">
                  <div class="absolute inset-0 flex flex-col items-center justify-center font-black font-orbitron">
                    <h4 class="text-white text-[32px] leading-[39px] font-bold text-center">
                      {{ timer.split(' ')[0].substring(0, timer.split(' ')[0].length - 1) }}
                    </h4>
                    <h6 class="text-xs font-bold leading-6 text-center font-inter text-white">
                      DAYS
                    </h6>
                  </div>
                </div>

                <div class="relative rounded-[10px] h-[70px] w-[70px] border-[2px] border-[#5C3EB7] bg-black/20 shadow-[0_6px_50px_0_#5C3EB7]">
                  <div class="absolute inset-0 flex flex-col items-center justify-center font-black font-orbitron">
                    <h4 class="text-white text-[32px] leading-[39px] font-bold text-center">
                      {{ timer.split(' ')[1].substring(0, timer.split(' ')[1].length - 1) }}
                    </h4>
                    <h6 class="text-xs font-bold leading-6 text-center font-inter text-white">
                      HRS
                    </h6>
                  </div>
                </div>

                <div class="relative rounded-[10px] h-[70px] w-[70px] border-[2px] border-[#5C3EB7] bg-black/20 shadow-[0_6px_50px_0_#5C3EB7]">
                  <div class="absolute inset-0 flex flex-col items-center justify-center font-black font-orbitron">
                    <h4 class="text-white text-[32px] leading-[39px] font-bold text-center">
                      {{ timer.split(' ')[2].substring(0, timer.split(' ')[2].length - 1) }}
                    </h4>
                    <h6 class="text-xs font-bold leading-6 text-center font-inter text-white">
                      MIN
                    </h6>
                  </div>
                </div>

                <div class="relative rounded-[10px] h-[70px] w-[70px] border-[2px] border-[#5C3EB7] bg-black/20 shadow-[0_6px_50px_0_#5C3EB7]">
                  <div class="absolute inset-0 flex flex-col items-center justify-center font-black font-orbitron">
                    <h4 class="text-white text-[32px] leading-[39px] font-bold text-center">
                      {{ timer.split(' ')[3].substring(0, timer.split(' ')[3].length - 1) }}
                    </h4>
                    <h6 class="text-xs font-bold leading-6 text-center font-inter text-white">
                      SEC
                    </h6>
                  </div>
                </div>
              </div>
              <div v-else class="text-white text-2xl md:text-[36px] md:leading-[48px] font-bold py-[11px]">
                Leaderboard Ended
              </div>
            </div>
          </div>
          <div class="flex flex-col items-center justify-center my-10 md:flex-row">
            <div class="block">
              <label class="toggle-switch md:mt-8 bg-tansparent font-orbitron">
                <input type="checkbox" @change="changeLeaderboard()" v-model="selectedLeaderboard" />
                <div class="slider"></div>
                <div class="left-label relative overflow-hidden py-4 md:py-5 w-[252px] md:w-[347px] h-[60px] md:h-[72px] rounded-2xl border-[2px] border-white text-white" :class="{
                  'bg-[#191822]': selectedLeaderboard,
                  'bg-transparent': !selectedLeaderboard
                }">
                  <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                    class="absolute inset-y-0 left-0 h-full pointer-events-none" />
                  <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                    class="absolute inset-y-0 right-0 h-full pointer-events-none" />
                  <p class="text-center text-base md:text-2xl md:leading-[28px] font-bold z-20 whitespace-nowrap">
                    Current Leaderboard
                  </p>
                </div>
                <div class="right-label overflow-hidden relative py-4 md:py-5 w-[252px] md:w-[347px] h-[60px] md:h-[72px] rounded-2xl border-[2px] border-white text-white" :class="{
                  'bg-[#191822]': !selectedLeaderboard,
                  'bg-transparent': selectedLeaderboard
                }">
                  <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                    class="absolute inset-y-0 left-0 h-full pointer-events-none" />
                  <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                    class="absolute inset-y-0 right-0 h-full pointer-events-none" />
                  <p class="text-center text-base md:text-2xl md:leading-[28px] font-bold z-20 whitespace-nowrap">
                    Previous Leaderboard
                  </p>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div v-if="loading == true" class="mt-10 text-xl font-bold text-center text-white md:text-4xl"
          style="font-family: Secular One, sans-serif">
          Loading Leaderboard...
        </div>
        <div v-if="loading == false" class="relative w-full mt-20 sm:mt-[151px] ">
          <div
            class="flex flex-col lg:flex-row justify-center items-center mt-14 gap-[110px] lg:gap-10 xl:gap-12 md:mb-16 lg:mb-0 lg:mt-16">
            <div class="flex flex-col-reverse lg:flex-row flex-nowrap gap-[110px] lg:gap-10 xl:gap-12">
              <div v-motion-pop-visible class="flex flex-col h-full items-center md:h-full lg:h-full">
                <div
                  class="p-2.5 pb-[10px] md:pb-1 w-[300px] shadow-[-3px_4px_15px_2px_#5C3EB7] sm:shadow-[-8px_4px_30px_2px_#5C3EB7] h-[284px] md:w-[240px] lg:w-[300px] lg:h-full xl:w-[325px] rounded-[10px] border border-white/20 leaderboard-bg">
                  <div class="relative flex flex-col items-center justify-center pt-2 lg:py-4 rounded-3xl">
                    <img src="@/assets/leaderboard-profile2.png" alt="Rank Image"
                      class="absolute w-auto h-[120px] -top-[90px] sm:-top-[80px] object-contain" />
                    <div class="flex flex-col items-center justify-center w-full pb-[14px] mt-[28px] md:pb-0">
                      <p
                        class="text-white font-inter text-xl leading-6 font-bold overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap">
                        {{
                          top3.length > 0
                            ? getMaskedUsername(top3[1]?.name)
                            : ""
                        }}
                      </p>
                      <p class="mt-6 text-white text-4xl leading-[44px] uppercase font-bold overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap font-inter">
                        {{ top3.length > 0 ? Number(top3[1]?.wagered.this_month.toFixed(2)).toLocaleString() : "" }}
                      </p>
                      <p class="text-sm font-normal text-white uppercase lg:text-base font-inter">
                        Wager
                      </p>
                      <div class="flex justify-center items-center mt-6 border-[2px] border-white bg-gradient-to-r from-[#5C3EB7] rounded-2xl to-[#2d1c63] relative py-[21px] px-[30px] w-fit">
                        <p class="text-white font-bold text-2xl leading-[30px] text-center font-orbitron">
                        ${{ getRewardValue(1) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-motion-pop-visible
                class="top-0 flex flex-col items-center md:h-full lg:h-full lg:relative md:mt-[-113px]">
                <div
                  class="p-2.5 pb-[10px] md:pb-1 rounded-[10px] w-[300px] h-[284px] shadow-[-3px_4px_15px_2px_#5C3EB7] sm:shadow-[-8px_4px_30px_2px_#5C3EB7] md:w-[240px] lg:w-[300px] lg:h-full xl:w-[325px] leaderboard-bg">
                  <div class="relative flex flex-col items-center justify-center pt-2 lg:py-4 rounded-3xl">
                    <img src="@/assets/leaderboard-profile1.png" alt="Rank Image"
                    class="absolute w-auto h-[120px] -top-[90px] sm:-top-[80px] object-contain" />
                    <div class="flex flex-col items-center justify-center w-full mt-[28px] pb-[14px] md:pb-0">
                      <p
                        class="text-white font-internet text-xl leading-6 font-normal overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap">
                        {{
                          top3.length > 0
                            ? getMaskedUsername(top3[0]?.name)
                            : ""
                        }}
                      </p>
                      <p class="mt-6 text-white text-4xl leading-[44px] uppercase font-normal overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap font-internet">
                        {{ top3.length > 0 ? Number(top3[0]?.wagered.this_month.toFixed(2)).toLocaleString() : "" }}
                      </p>
                      <p class="text-sm font-black text-white uppercase lg:text-base font-montserrat">
                        Wager
                      </p>
                      <div class="flex justify-center items-center mt-6 border-[2px] border-white bg-gradient-to-r from-[#5C3EB7] rounded-2xl to-[#2d1c63] relative py-[21px] px-[30px] w-fit">
                        <p class="text-white font-bold text-4xl leading-[30px] text-center font-orbitron">
                        ${{ getRewardValue(0) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-motion-pop-visible class="flex flex-col items-center md:h-full lg:h-full">
              <div
                class="p-2.5 pb-[10px] md:pb-1 rounded-[10px] border border-white/20 w-[300px] shadow-[-3px_4px_15px_2px_#5C3EB7] sm:shadow-[-8px_4px_30px_2px_#5C3EB7] h-[284px] md:w-[240px] lg:w-[300px] lg:h-full xl:w-[325px] leaderboard-bg">
                <div class="relative flex flex-col items-center justify-center pt-2 lg:py-4 rounded-3xl">
                  <img src="@/assets/leaderboard-profile3.png" alt="Rank Image"
                  class="absolute w-auto h-[120px] -top-[90px] sm:-top-[80px] object-contain" />
                  <div class="flex flex-col items-center justify-center w-full mt-[28px] pb-[14px] md:pb-0">
                    <p
                      class="text-white font-internet text-xl leading-6 font-normal overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap">
                      {{
                        top3.length > 0
                          ? getMaskedUsername(top3[2]?.name)
                          : ""
                      }}
                    </p>
                    <p class="mt-6 text-white text-4xl leading-[44px] uppercase font-normal overflow-hidden max-w-[230px] md:max-w-full text-ellipsis whitespace-nowrap font-internet">
                        {{ top3.length > 0 ? Number(top3[2]?.wagered.this_month.toFixed(2)).toLocaleString() : "" }}
                      </p>
                      <p class="text-sm font-black text-white uppercase lg:text-base font-montserrat">
                        Wager
                      </p>
                    <div class="flex justify-center items-center mt-6 border-[2px] border-white bg-gradient-to-r from-[#5C3EB7] rounded-2xl to-[#2d1c63] relative py-[21px] px-[30px] w-fit">
                      <p class="text-white font-bold text-4xl leading-[30px] text-center font-orbitron">
                       ${{ getRewardValue(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mx-auto max-w-[1180px] w-full">
        <div class="flex flex-col items-center justify-center w-full mt-16">
  <h2 class="text-[#FF0000] text-xl md:text-3xl font-bold font-orbitron uppercase tracking-wide mb-4">
    GRAND PRIZE
  </h2>
  <div
    class="flex justify-center items-center gap-4 px-6 py-5 rounded-xl border border-[#FFEB3B] bg-[#191822]/90 shadow-[0_0_10px_#FFEB3B] max-w-[600px] w-full"
  >
    <span class="text-2xl md:text-3xl drop-shadow-[0_0_10px_#FFEB3B]">🏆</span>
    <div class="text-white text-sm md:text-base leading-tight">
      <p class="font-bold text-[#FFEB3B] drop-shadow-[0_0_10px_#FFEB3B] uppercase">
        RECORD A VIDEO WITH ME
      </p>
      <p class="text-white">
      $2,000 video 50/50 split or take $600
      </p>
    </div>
  </div>
</div>


          </div>

          <div
            class="flex justify-center mt-6 lg:mt-[40px] mb:mb-24 bg-transparent mx-auto max-w-[1280px] font-inter">
            <section
              class="relative flex flex-col items-center w-full mt-0 mb-24 mx-auto max-w-[1180px] rounded-2xl bg-[#191822E5]/90 z-30 shadow-[-3px_4px_15px_2px_#5C3EB7] sm:shadow-[-8px_4px_30px_2px_#5C3EB7]">
              <div class="flex justify-between w-full py-4 text-lg font-black font-inter bg-[#5C3EB7] rounded-t-2xl">
                <div class="ml-4 md:ml-8 w-1/4 text-lg leading-6 text-left text-white">RANK</div>
                <div class="w-1/4 text-lg leading-6 text-center text-white">USER</div>
                <div class="sm:w-1/4 text-lg leading-6 text-center text-white"> WAGERED</div>
                <div class="mr-4 md:mr-8 w-1/5 sm:w-1/4 text-lg leading-6 text-right text-white"> PRIZE</div>
              </div>

              <div v-motion-pop-visible v-for="(item, index) in topRest" :key="index"
                class="flex justify-between w-full py-3 my-2 transition-transform rounded-xl hover:scale-[1.02] font-inter">
                <div
                  class="w-1/4 pl-4 md:pl-8 font-normal tracking-wide text-left text-white uppercase text-base">
                  {{ getOrdinalSuffix(index + 4) }}
                </div>
                <div class="w-1/4 font-normal text-center text-white truncate text-base">
                  {{ getMaskedUsername(item?.name) }}
                </div>
                <div class="w-1/4 font-normal text-center text-white truncate text-base">
                  $ {{ item?.wagered.this_month.toFixed(2)  }}
                </div>
                <div class="w-1/4 pr-4 md:pr-8 font-normal text-right text-white text-base">
                  <span class="text-[#5C3EB7]">$</span>
                  {{ getRewardValue(index + 3) }}
                </div>
              </div>
              <img src="@/assets/table-bg.webp"
                class="absolute inset-0 left-0 -z-10 hidden md:block object-cover h-full w-full rounded-2xl"
                alt="planet 1" />
              <img src="@/assets/table-bg-sp.webp"
                class="absolute inset-0 left-0 -z-10  block md:hidden object-cover h-full w-full rounded-2xl"
                alt="planet 1" />
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

export default {
  name: "LeaderboardSection",
  data() {
    return {
      top3: [],
      topRest: [],
      timer: "",
      topForMobile: [],
      selectedLeaderboard: false,
      currentLeaderboard: [],
      prevLeaderboard: [],
      showPreviousLeaderboard: process.env.VUE_APP_SHOW_PREVIOUS_LEADERBOARD === "true",

      startDate: null,
      endDate: null,

      notFormattedEndDate: null,

      loading: false,
    };
  },
  methods: {
    async init() {
      const baseUrl = process.env.VUE_APP_BASE_API;
      this.loading = true;
      await axios
        .get(`${baseUrl}/api/leaderboard/goated`, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            "x-secret-key": process.env.VUE_APP_X_SECRET_KEY,
          },
        })
        .then((res) => {
          axios
            .get(`${baseUrl}/api/leaderboard/goated?previous=true`, {
              headers: {
                "x-api-key": process.env.VUE_APP_X_API_KEY,
                "x-secret-key": process.env.VUE_APP_X_SECRET_KEY,
              },
            })
            .then((rest) => {
              // const startDateSplit = res.data.startDate.split('-');
              // const endDateSplit = res.data.endDate.split('-');
              this.startDate = moment(res.data.startDate).format(
                "MMMM DD, YYYY"
              );
              this.endDate = moment(res.data.endDate).format("MMMM DD, YYYY");
              this.notFormattedEndDate = res.data.endDate;
              this.currentLeaderboard = res.data.leaderboard;
              this.prevLeaderboard = rest.data.leaderboard;
              this.changeLeaderboard();
              this.startTimer();
              this.loading = false;
            });
        });
    },
    changeLeaderboard() {
      if (this.selectedLeaderboard == false) {
        const leaderboard = this.currentLeaderboard;
        this.top3 = leaderboard.slice(0, 3).map((item) => {
          return item;
        });

        this.topRest = leaderboard.slice(3, 8).map((item) => {
          return item;
        });

        this.topForMobile = leaderboard.slice(0, 8).map((item) => {
          return item;
        });
      } else {
        const leaderboard = this.prevLeaderboard;
        this.top3 = leaderboard.slice(0, 3).map((item) => {
          return item;
        });

        this.topRest = leaderboard.slice(3, 10).map((item) => {
          return item;
        });

        this.topForMobile = leaderboard.slice(0, 10).map((item) => {
          return item;
        });
      }
    },
    getMaskedUsername(username) {
      if (username.length <= 6) {
        return username;
      }
      return (
        username.substring(0, 3) +
        "*****" +
        username.substring(username.length - 3)
      );
    },
    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    getRewardValue(rank) {
      const prizes = JSON.parse(
        this.selectedLeaderboard
          ? process.env.VUE_APP_PREVIOUS_PRIZES
          : process.env.VUE_APP_CURRENT_PRIZES
      );

      return prizes[rank];
    },
    startTimer() {
      const getNextTargetDate = () => {
        const now = moment().utc();
        let targetDate = moment(`${this.notFormattedEndDate}`)
          .utc()
          .subtract(1, "seconds");

        if (now.isAfter(targetDate)) {
          targetDate.add(1, "M");
        }

        return targetDate;
      };

      let targetDate = getNextTargetDate();
      let timerInterval;

      const updateTimer = () => {
        const nowEst = moment.tz("UTC");
        const distance = targetDate.diff(nowEst);
        if (distance >= 0) {
          const duration = moment.duration(distance);
          const days = Math.floor(duration.asDays());
          const hours = duration.hours();
          const minutes = duration.minutes();
          const seconds = duration.seconds();

          this.timer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else {
          this.timer = "Leaderboard ended";
          clearInterval(timerInterval);
        }
      };

      updateTimer();
      timerInterval = setInterval(updateTimer, 1000);
    },
    isMobile() {
      return window?.innerWidth < 768; // Adjust based on your 'lg' breakpoint in Tailwind CSS config
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 726px;
  height: 72px;
  /* background: linear-gradient(to right, #121212, #461B83 , #121212); */
  border-radius: 20px;
  padding: 0 8px;
  cursor: pointer;
  

  @media screen and (max-width: 640px) {
    width: 252px;
    height: 60px;
  }
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  
}

.toggle-switch .slider {
  position: absolute;
  left: 0;
  top: 5px;
  border-radius: 16px;
  width: 347px;
  height: 72px;
  background: linear-gradient(90deg, #5C3EB7 0%, #2D1C63 100%);
  transition: transform 0.3s ease;
  box-shadow: -14px 10px 44px -20px rgba(255, 255, 255, 1);

  @media screen and (max-width: 640px) {
    width: 252px;
    height: 60px;
  }
}

.toggle-switch input:checked + .slider {
  transform: translateX(377px);

  @media screen and (max-width: 640px) {
    transform: translateY(75px);
  }
}

.toggle-switch span {
  font-size: 35px;
  font-weight: bold;
  z-index: 1;
  padding: 0 8px;

}

.toggle-switch .left-label {
  position: absolute;
  left: 0px;
  margin-top: 5px;
  font-weight: 50;
  /* font-weight: 50;  background: linear-gradient(90deg, #5C3EB7 0%, #2D1C63 100%); */
  box-shadow: -14px 10px 44px -20px rgba(255, 255, 255, 1);

  @media screen and (max-width: 640px) {
    top: 0;
    /* left: 100px; */
  }
}

.toggle-switch .right-label {
  position: absolute;
  right: 2px;
  margin-top: 5px;
  /* font-weight: 50;  background: linear-gradient(90deg, #5C3EB7 0%, #2D1C63 100%); */
  box-shadow: -14px 10px 44px -20px rgba(255, 255, 255, 1);

  @media screen and (max-width: 640px) {
    bottom: -80px;
  }
}

.bg-leaderboard-bg {
  /* background-image: url('../assets/leaderboard-bg.avif'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.leaderboard-bg {
  /* background-image: url('../assets/leaderboard-box.avif'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
